import {
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import * as _ from 'lodash';

import { FormGroupService } from '../form-group.service';


@Component({
  moduleId: module.id,
  selector: 'form-control-char-counter',
  template: '{{charsLeft}}',
  styleUrls: ['form-control-char-counter.component.scss'],
})
export class FormControlCharCounterComponent {

  @HostBinding('class.form-control-char-counter') formClass: boolean = true;

  @HostBinding('class.has-error') get hasError(): boolean {
    return this.charsLeft < 0;
  }

  @HostBinding('class.is-visible') get isVisible(): boolean {
    return this.hasError || this.focused;
  }

  @Input() maxLength: number;

  get focused(): boolean {
    return _.get(this.formGroupService, 'model.focused', false);
  }

  get charLength(): number {
    return _.get(this.formGroupService, 'model.charLength', 0);
  }

  constructor(
    private formGroupService: FormGroupService,
  ) {}

  get charsLeft(): number {
    return this.maxLength - this.charLength;
  }
}
